import React from 'react';

interface Props {
    record: {
        name: string;
    };
}

export const ResourceTooltip = ({ record }: Props) => {
    return <div>{record.name}</div>;
};
